import React, { useEffect, useCallback, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import WifiTetheringIcon from '@material-ui/icons/WifiTethering';
import { InputBase, Card, CardContent, CardMedia, CircularProgress, Grid, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { isUndefined, isEmpty, isNull } from 'lodash';

import './index.scss';
import { uploadContentService } from '../../../services';

import { useHistory } from 'react-router-dom';
import PlaylistModal from '../Modals/ManagePlaylistModal';
import { CollectionsOutlined, MusicNoteOutlined } from '@material-ui/icons';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#252525",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        color: theme.palette.common.white,
    },
    button: {
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#424242",
        },
        '&:nth-of-type(even)': {
            backgroundColor: "#252525",
        },
    },
}))(TableRow);

function createData(SPILLELISTER, BUTTON) {
    return { SPILLELISTER, BUTTON };
}

const useStyles = makeStyles((theme) => ({
    table: {
        maxWidth: 2000
    },
    button: {
        marginTop: 10,
        height: 40,
        width: 200,
        fontSize: 15,
        fontWeight: 'bold',
        color: '#ffffff',
        backgroundColor: '#6C6C6C'
    },
    buttonFloatRight: {
        marginTop: 10,
        height: 40,
        width: 200,
        fontSize: 15,
        fontWeight: 'bold',
        color: '#ffffff',
        backgroundColor: '#6C6C6C',
        float: 'right'
    },
    cardStyle: {
        width: '210px',
        height: '80px',
        color: 'white',
        display: 'flex',
        background: '#3C3C3C',
        marginRight: '5px',
        marginLeft: '25px',
        marginTop: '10px',
    },
    coverPlaylist: {
        marginTop: '25px',
        marginLeft: '10px',
        width: 50,
        height: 50,
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '-3px'
    },
    truncate: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingTop: '5px',
        paddingBottom: '5px',
        width: '130px'
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        height: '1em',
        marginTop: '8px',
        maxWidth: '200px',
        minWidth: '150px',
        border: '1px solid #ccc!important',
        borderRadius: '16px',
        marginLeft: '10px',
        marginTop: '20px',
        marginRight: '10px'
    },
}));

export default function PlaylistTable() {
    const classes = useStyles();
    const history = useHistory();

    const [playlist, setPlaylist] = useState({
        original: [],
        new: []
    });
    const { user } = useSelector(state => state.userAuthentication);
    const [isPlaylistModalShow, setIsPlaylistModalShow] = useState(false);
    const [modalInfo, setModalInfo] = useState({
        id: undefined,
        modalType: 'add',
        editInfo: undefined
    });

    const [searchQueryInput, setSearchQueryInput] = useState('');

    const handleClickPlaylist = async (id = undefined, modalType = 'add', editInfo = undefined) => {
        setIsPlaylistModalShow(true);
        if (modalType === 'edit') {
            if (editInfo.supportsAudio === true)
                editInfo.mediaType = 'audio'
            else
                editInfo.mediaType = 'imgvideo';
        }
        setModalInfo({
            id: id,
            modalType: modalType,
            editInfo: editInfo
        });
    }

    const getPlaylist = useCallback(async () => {
        if (!isUndefined(user)) {
            const res = await uploadContentService.uploadContentPlaylist(user);
            setPlaylist({
                original: res.items,
                new: res.items
            });
        }
    }, [user]);

    const handleChangeSearchInput = (e) => {
        setSearchQueryInput(e.target.value);
    }

    useEffect(() => {
        getPlaylist();
    }, [getPlaylist]);

    const searchPlaylist = () => {
        if(searchQueryInput === '') {
            setPlaylist({
                original: playlist.original,
                new:  playlist.original
            });
        }
        else {
            let newPlaylist = [];
            playlist.original.map(item => {
                if(item.name.toLowerCase().includes(searchQueryInput.toLowerCase())) {
                    newPlaylist.push(item);
                }
            });
            setPlaylist({
                original: playlist.original,
                new: newPlaylist
            });
        }
    }

    const handleKeyDownSearchInput = (event) => {
        if (event.key === 'Enter') {
            searchPlaylist();
        }
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <span className="span-design">
                <div className="icon-design"><WifiTetheringIcon /> PLAYLIST </div>
                <h3 className="text-design">  CONTENT </h3>
            </span>
            <TableContainer component={Paper} className={classes.table} style={{ backgroundColor: '#272727' }}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">DYNAMIC PLAYLIST</StyledTableCell>
                            <StyledTableCell align="right">&nbsp;</StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <StyledTableCell>
                                <Button
                                    onClick={handleClickPlaylist}
                                    variant="contained"
                                    data-value="addPlaylist"
                                    className={classes.button}
                                >
                                    ADD PLAYLIST
                                </Button>
                                <InputBase
                                        value={searchQueryInput}
                                        placeholder="Indtast s�geord"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            handleChangeSearchInput(e);
                                        }}
                                        autoComplete='off'
                                        id='searchQueryText'
                                        onKeyDown={(e) => {
                                            e.stopPropagation();
                                            handleKeyDownSearchInput(e);
                                        }}
                                    />
                                    <Button variant="contained" color="default" onClick={(e) => {
                                        e.stopPropagation();
                                        searchPlaylist()
                                    }} style={{ marginTop: '0px', marginRight: '5px', marginBottom: '5px' }}
                                        id='submitButton'>
                                        Search
                                    </Button>
                            </StyledTableCell>
                            {/* <StyledTableCell align="right">&nbsp;</StyledTableCell> */}
                            {/* <StyledTableCell align="left">
                                <Grid container>
                                    
                                </Grid>
                            </StyledTableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isUndefined(playlist) ? (
                            <Grid container spacing={1}
                                alignItems={'flex-start'}
                                justify={'flex-start'}
                                style={{ margin: '20px' }}
                            >
                                {
                                    playlist.new.length > 0 &&
                                    [...playlist.new].map((item, index) => (
                                        <Card key={'playlist99' + index} className={classes.cardStyle}
                                            title={item.name}>
                                            <Grid container className={classes.details}>
                                                {
                                                    item.supportsAudio === true ?
                                                        <MusicNoteOutlined style={{ fontSize: '80px' }} />
                                                        :
                                                        <CollectionsOutlined style={{ fontSize: '80px' }} />
                                                }
                                                <CardContent style={{ marginLeft: '-10px', marginTop: '-10px' }}>
                                                    <Typography className={classes.truncate} style={{
                                                        fontSize: '17px',
                                                        color: 'white',
                                                        textAlign: 'left'
                                                    }}>
                                                        {item.name}
                                                    </Typography>

                                                    <Typography
                                                        onClick={() => {
                                                            handleClickPlaylist(item.id, 'edit', item);
                                                        }}
                                                        style={{
                                                            fontSize: '14px',
                                                            color: 'white',
                                                            textAlign: 'right',
                                                            marginTop: '10px',
                                                            marginRight: '10px',
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        Edit
                                                    </Typography>

                                                </CardContent>
                                            </Grid>
                                        </Card>
                                    ))
                                }
                            </Grid>
                        ) : (
                            <div className="loader">
                                <CircularProgress />
                            </div>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {isPlaylistModalShow ? (<PlaylistModal modalShow={isPlaylistModalShow}
                modalState={setIsPlaylistModalShow}
                id={modalInfo.id} modalType={modalInfo.modalType}
                editInfo={modalInfo.editInfo} />) : ''}
        </div>
    );
}